var map = {
	"./blue/down.png": "./src/assets/image/blue/down.png",
	"./purple/down.png": "./src/assets/image/purple/down.png",
	"./red/down.png": "./src/assets/image/red/down.png",
	"./yellow/down.png": "./src/assets/image/yellow/down.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/down\\.png$";